import { Injectable } from '@angular/core';
import {  HttpGeneralService } from '../../shared';
import {Special} from './special';
import {Speciality} from './speciality';
import { CONFIG } from '../../shared/config';
let specialsUrl = CONFIG.baseUrls.specials;

@Injectable()
export class SpecialService {
    constructor(private httpGeneralService: HttpGeneralService) {
    }

    specialityPrototype (){
        return {
            code: 0,
            nameEn: '',
            nameAr: '',
            parentCode: 0,
            active: 0
        }
    }

    searchSpecials(k?: string) {
        return this.httpGeneralService.search(k, specialsUrl)
    }

    getSpecials(parentId: number) {
        return this.httpGeneralService.get(parentId, specialsUrl)

    }

    addSpecial(special: Special) {

        return this.httpGeneralService.add<Special>(special, specialsUrl)

    }



    getSpecial(id: number) {
        return this.httpGeneralService.get(id, specialsUrl)

    }


    updateSpecial(special: Special) {
        return this.httpGeneralService.update<Special>(special.code, special, specialsUrl)



    }

    deleteSpecial(special: Special) {
        return this.httpGeneralService.delete<number>(special.code, `${specialsUrl}`)

    }
}
